import { useField } from "formik";
import React from "react";

import { HandheldOptimizationChoice } from "@gamedev-web/one-gaming-crm";

import { XboxHandheldGamingDeveloperResourceHubUrl } from "../../constants/urls";
import { isHandheldOptimizationSelected } from "../../helpers/handheldOptimizationHelpers";
import { useStrings } from "../../localization/localizationHelpers";
import { RadioOptionsField } from "../RadioOptionsField";
import { SectionTitle } from "../SectionTitle";
import * as styles from "./HandheldOptimizationSection.module.css";

type HandheldOptimizationSectionProps = Readonly<{
  isSaving: boolean;
}>;

export const HandheldOptimizationSection = ({ isSaving }: HandheldOptimizationSectionProps) => {
  const [field] = useField<string | undefined>("handheldOptimization");
  const [
    title,
    introduction,
    programDescription,
    resourceHubLabel,
    yesOption,
    noOption,
    notSureOption,
    warning,
  ] = useStrings(
    "handheldOptimizationTitle",
    "handheldOptimizationIntroduction",
    "handheldOptimizationProgramDescription",
    "handheldOptimizationResourceHubLabel",
    "handheldOptimizationYesOption",
    "handheldOptimizationNoOption",
    "handheldOptimizationNotSureOption",
    "handheldOptimizationWarning"
  );

  return (
    <section className={styles.handheldOptimizationSection}>
      <SectionTitle title={title} />
      <div className={styles.copy}>
        <p>{introduction}</p>
        <p>
          {programDescription}{" "}
          <a
            href={XboxHandheldGamingDeveloperResourceHubUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            {resourceHubLabel}
          </a>
        </p>
      </div>
      <RadioOptionsField
        options={[
          { value: HandheldOptimizationChoice.yes, label: yesOption },
          { value: HandheldOptimizationChoice.no, label: noOption },
          { value: HandheldOptimizationChoice.notSure, label: notSureOption },
        ]}
        name="handheldOptimization"
        title={title}
        listAsColumn={true}
        isRequiredField={true}
        isSaving={isSaving}
      />
      {isHandheldOptimizationSelected(field.value) && (
        <p className={styles.warning} role="alert">
          {warning}
        </p>
      )}
    </section>
  );
};
